var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"story-box text-center\"><div class=\"image-container\"><img src=\"{{$ctrl.imageSrc}}\" class=\"story-image fluid-width-img\"></div><div class=\"story-box-infos\"><p ng-transclude=\"title\" class=\"title\"></p><div ng-transclude=\"subtitle\" class=\"subtitle text-small\"></div><a ng-href=\"{{$ctrl.href}}\" target=\"_self\" ng-transclude=\"linkText\"></a></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-story-card-mini.jade
 ** module id = 3525
 ** module chunks = 3
 **/